import "core-js/stable"
import "regenerator-runtime/runtime"
import "@stripe/stripe-js"
// window.global ||= window;
import $ from "jquery"
import { scan } from "react-scan"

window.$ = $

import BootstrapContainer from "@/components/BootstrapContainer"
import QueryProvider from "@/query/provider"
import store from "@/store/store"
import ReactDOM from "react-dom"
import viewportUnitsBuggyfill from "viewport-units-buggyfill"
import hacks from "viewport-units-buggyfill/viewport-units-buggyfill.hacks"

// import { IS_DEV } from "./constants"

scan({ enabled: false })

window.viewportUnitsBuggyfill = viewportUnitsBuggyfill
viewportUnitsBuggyfill.init({ hacks })

function runWavelength() {
  document.addEventListener(
    "DOMContentLoaded",
    () => {
      /*
       * DON'T REMOVE THIS -- currently doing a hack where we access the store from the
       * Window in /frontend/util/functions/wrapError. if nowhere in the application is accessing
       * The store from the window, then we can remove this
       */
      window.store = store

      // Render BootstrapContainer which will handle fetching and loading states
      ReactDOM.render(<BootstrapContainer store={store} />, document.getElementById("root"))
    },
    { capture: true },
  )
}

if (!global.Intl) {
  require.ensure(["intl", "intl/locale-data/jsonp/en.js"], (require) => {
    require("intl")
    require("intl/locale-data/jsonp/en.js")
    runWavelength()
  })
} else {
  runWavelength()
}

export default runWavelength
